import { getCookie, hasCookie } from 'cookies-next';
import Text from '@/components/shared/Text';
import { DownloadFileIcon } from '@/icons';
import { cn } from '@/utils/mergeClassName';
import { LOCALE_KEY } from '../LocaleButton';

interface DownloadCardProps {
  filePath?: string;
  fileName?: string;
  title?: string;
  date?: Date | string;
  className?: string;
}
export const DownloadCard = ({ filePath, fileName, title, date, className }: DownloadCardProps) => {
  const currentLocale = hasCookie(LOCALE_KEY) ? getCookie(LOCALE_KEY)?.trim() : 'pt-BR';
  const newDate = date && new Date(`${date}T12:00:00`);

  return (
    <div
      className={cn(
        'flex h-[104px] w-full items-center rounded-lg border border-solid border-grey-300 bg-white px-6 py-4',
        className
      )}
    >
      <a
        href={filePath}
        download={fileName}
        target="_blank"
        aria-label="Download do arquivo"
        className="flex w-full items-center justify-between gap-4"
        rel="noreferrer"
      >
        <div>
          <Text className="text-blue-200" weight="semibold">
            {title}
          </Text>
          {newDate && (
            <Text className="text-grey-600" size="sm">
              {newDate.toLocaleDateString(currentLocale)}
            </Text>
          )}
        </div>
        <DownloadFileIcon width={24} height={24} className="grow-1 shrink-0 text-grey-800" />
      </a>
    </div>
  );
};
